window.reduceAnimations = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// ========== UTILS ==========

function scrollToElement(id, offset) {
    offset = typeof offset !== 'undefined' ? offset : 150;
    jQuery('html, body').animate({
        scrollTop: jQuery(id).offset().top - offset
    }, 'slow');
}

function toggleScrollClass() {
    if (jQuery(window).width() <= 640) return;

    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            jQuery('html body').removeClass('isScrolling');
        } else {
            jQuery('html body').addClass('isScrolling');
        }
        prevScrollpos = currentScrollPos;
    };
}

function animProducts(selector) {
    gsap.defaults({ ease: "power3" });
    gsap.set(selector, { y: 100, opacity: 0 });

    ScrollTrigger.batch(selector, {
        once: true,
        start: "top bottom",
        onEnter: function (batch) {
            gsap.to(batch, {
                opacity: 1,
                y: 0,
                stagger: { each: 0.15, axis: "x" }
            });
        }
    });
}

function openCloseProject(elem) {
    elem.nextAll("div").first().slideToggle();
}

function initSearchPopup() {
    var $searchModal = jQuery('.search-modal');

    jQuery('.js-trigger-search').on('click', function (e) {
        e.preventDefault();
        $searchModal.toggleClass('search-modal__modal--opened');
        setTimeout(function () {
            jQuery('form input.js-search-input').focus();
        }, 100);
    });

    jQuery('.js-close-search').on('click', function () {
        $searchModal.removeClass('search-modal__modal--opened');
    });
}

function initBackToTop() {
    if (jQuery(window).width() <= 1024) return;

    jQuery(window).on('scroll', function () {
        if (jQuery(this).scrollTop() > 300) {
            jQuery(".desktop-backTop").fadeIn();
        } else {
            jQuery(".desktop-backTop").fadeOut();
        }
    });

    jQuery(".scroll-back-top, .bt_top").on('click', function (e) {
        e.preventDefault();
        jQuery("html, body").animate({ scrollTop: 0 }, 0);
    });
}

function initRealisationAnimations() {
    if (jQuery(".realisation-grid__item").length) {
        animProducts(".realisation-grid__item");
    }
    if (jQuery(".list-clients__item").length) {
        animProducts(".list-clients__item");
    }
}

function initBurgerMenu() {
    jQuery(".burger-button").on("click", function () {
        jQuery(this).toggleClass("burger-opened");
    });
}

function initHomeDossier() {
    var speed = window.reduceAnimations ? 'fast' : '';

    jQuery('.project-close__btn2').hide();

    jQuery('.dossier-list__item').on("click", function () {
        jQuery(".detail-to-show", this).slideToggle(speed);
        jQuery('.dossier-featured').hide();
        jQuery('.project-close__btn2').show();
        jQuery('.project-close').hide();
        jQuery('.home-dossier__list').css('padding-top', '0px');
        scrollToElement(this, 200);
    });

    jQuery('.home-dossier .project-close').on('click', function () {
        jQuery('.project-close__btn2').show();
        jQuery(this).hide();
        jQuery('.dossier-featured').slideUp(speed);
        jQuery('.home-dossier__list').css('padding-top', '0px');
    });

    jQuery('.project-close__btn2').on('click', function () {
        jQuery(this).hide();
        jQuery(".detail-to-show").hide();
        jQuery('.project-close').show();
        jQuery('.dossier-featured').slideDown(speed);
        jQuery('.home-dossier__list').css('padding-top', '10.625rem');
    });
}

function initAccordion() {
    var i = 1;

    jQuery('.rte h2').each(function () {
        if (jQuery(this).next().is('blockquote')) {
            jQuery(this).addClass('accordion-drag clearfix innerAccordeon' + i);
            i++;
        }
    });

    if (i === 1) return;

    i = 1;

    jQuery('.rte blockquote').each(function () {
        jQuery(this).addClass('accordion-content clear innerAccordeon' + i);
        jQuery(".innerAccordeon" + i).wrapAll("<div class='accordion-item clear' />");
        i++;
    });

    var allPanels = jQuery('.accordion-content').hide();

    jQuery('.accordion-drag').on('click', function () {
        var $this = jQuery(this);
        var $parent = $this.parents('.accordion-item');
        var isOpen = $parent.hasClass('open');

        if (!isOpen) {
            allPanels.slideUp();
            jQuery('.accordion-item').removeClass('open');
            $this.next().slideDown();
            $parent.addClass('open');
        } else {
            allPanels.slideUp();
            jQuery('.accordion-item').removeClass('open');
        }

        return false;
    });
}

function scrollBodyClassOnScroll() {
    jQuery(window).on('scroll', function () {
        if (jQuery(window).scrollTop() >= 200) {
            jQuery("body").addClass("scrollUp");
        } else {
            jQuery("body").removeClass("scrollUp");
        }
    });
}

// ========== SERVICES EXTERNES ==========

function loadOdooChat() {
    if (window.odoo_livechat_loaded) return;
    window.odoo_livechat_loaded = true;

    var chatButton = document.getElementById('odoo-chat-button');
    if (chatButton) {
        chatButton.style.opacity = '0.5';
        chatButton.innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size: 24px;"></i>';
        chatButton.disabled = true;
    }

    var script1 = document.createElement('script');
    script1.src = 'https://answeb.odoo.com/im_livechat/loader/1';
    script1.async = true;

    var script2 = document.createElement('script');
    script2.src = 'https://answeb.odoo.com/im_livechat/assets_embed.js';
    script2.async = true;

    script2.onload = function () {
        setTimeout(function () {
            if (chatButton) chatButton.style.display = 'none';
        }, 1000);
    };

    script1.onerror = script2.onerror = function () {
        console.error('Erreur lors du chargement du chat Odoo');
        if (chatButton) {
            chatButton.style.opacity = '1';
            chatButton.innerHTML = '<i class="fa fa-exclamation-triangle" style="font-size: 24px;"></i>';
            chatButton.title = 'Erreur de chargement du chat';
        }
    };

    document.head.appendChild(script1);
    document.head.appendChild(script2);
}

function loadUserWayAccessibility() {
    if (window.userway_accessibility_loaded) return;
    window.userway_accessibility_loaded = true;
    sessionStorage.setItem('userway_accessibility_enabled', 'true');

    var button = document.getElementById('userway-accessibility-button');
    if (button) {
        button.style.opacity = '0';
        button.innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size: 24px;"></i>';
        button.disabled = true;
    }

    var script = document.createElement('script');
    script.setAttribute('data-position', '3');
    script.setAttribute('data-account', 'yW20XMTNzT');
    script.src = 'https://cdn.userway.org/widget.js';
    script.async = true;

    (document.body || document.head).appendChild(script);
}

function initAccessibility() {
    if (sessionStorage.getItem('userway_accessibility_enabled') === 'true') {
        loadUserWayAccessibility();
    } else {
        var button = document.getElementById('userway-accessibility-button');
        if (button) {
            button.addEventListener('click', loadUserWayAccessibility);
        }
    }
}

// ========== INITIALISATION ==========

document.addEventListener('DOMContentLoaded', function () {
    initAccessibility();
});

jQuery(document).ready(function () {
    toggleScrollClass();
    initSearchPopup();
    initBackToTop();
    gsap.registerPlugin(ScrollTrigger);
    initRealisationAnimations();
    initBurgerMenu();
    //initHomeDossier();
    scrollBodyClassOnScroll();
    initAccordion();

    jQuery('.sections-pages__anchor').on('click', function (e) {
        e.preventDefault();
        scrollToElement("#contact", 200);
    });

    var chatButton = document.getElementById('odoo-chat-button');
    if (chatButton) {
        chatButton.addEventListener('click', function (e) {
            e.preventDefault();
            loadOdooChat();
        });
    }

    var accessibilityButton = document.getElementById('userway-accessibility-button');
    if (accessibilityButton) {
        accessibilityButton.addEventListener('click', function (e) {
            e.preventDefault();
            loadUserWayAccessibility();
        });
    }
});

jQuery(document).ready(function () {
    jQuery('#rdemande .input-group-field').hide();
    jQuery('#rdemande label.inline').on('click', function () {
        jQuery('#rdemande .input-group-field').slideToggle();
        jQuery(this).toggleClass('active');
    });
});